package org.ssoft.common.tools

@Suppress("unused", "NOTHING_TO_INLINE")
inline fun Boolean.toInt() = if(this) 1 else 0

@Suppress("unused", "NOTHING_TO_INLINE")
inline fun Int.toBoolean() = this == 1


@Suppress("unused")
fun Int.toByteArray(): ByteArray = ByteArray(4).apply {
    this[0] = ((this@toByteArray) shr 24).toByte()
    this[1] = ((this@toByteArray) shr 16).toByte()
    this[2] = ((this@toByteArray) shr 8).toByte()
    this[3] = (this@toByteArray).toByte()
}

@Suppress("unused")
fun ByteArray.toInt(): Int {
    return get(0).toInt() shl 24 or
        (get(1).toInt() and 0xFF shl 16) or
        (get(2).toInt() and 0xFF shl 8) or
        (get(3).toInt() and 0xFF)
}


@Suppress("unused")
fun Long.toByteArray(): ByteArray = ByteArray(8).apply {
    this[0] = ((this@toByteArray) shr 56).toByte()
    this[1] = ((this@toByteArray) shr 48).toByte()
    this[2] = ((this@toByteArray) shr 40).toByte()
    this[3] = ((this@toByteArray) shr 32).toByte()
    this[4] = ((this@toByteArray) shr 24).toByte()
    this[5] = ((this@toByteArray) shr 16).toByte()
    this[6] = ((this@toByteArray) shr 8).toByte()
    this[7] = (this@toByteArray).toByte()
}

@Suppress("unused")
fun ByteArray.toLong(): Long {
    return get(0).toLong() shl 56 or
        (get(1).toLong() and 0xFF shl 48) or
        (get(2).toLong() and 0xFF shl 40) or
        (get(3).toLong() and 0xFF shl 32) or
        (get(4).toLong() and 0xFF shl 24) or
        (get(5).toLong() and 0xFF shl 16) or
        (get(6).toLong() and 0xFF shl 8) or
        (get(7).toLong() and 0xFF)
}
